<div *ngIf="busy">
  Be right there... just practicing serves...
</div>
<div *ngIf="!busy && !ladderEnded && !isStalker && !isWaitingRoom">
  <div>
    <table class="home-header">
      <tr>
        <td rowspan="2" style="padding-right: 10px; cursor: pointer;">
          <img [routerLink]="['/profile']" [src]="avatar || '/assets/avatar.png'" height="70" width="70"
            style="border-radius: 50%; border: 3px solid black;" />
        </td>
        <td>
          Hi <b>{{player.getFullName()}}</b>.
          <span *ngIf="player.ladderId == null">
            You have not yet been assigned to a ladder. Please be patient...
          </span>
          <span *ngIf="player.ladderId != null">
            <span *ngIf="player.levelId <= 1">
              You have not yet been assigned a level for ladder <b>{{player.ladderName}}</b>.
              We are waiting for people to finish registering. Please be patient...
            </span>
            <span *ngIf="player.levelId > 1 && !player.isDoubles">
              You are in <b>{{player.levelName}}</b> on ladder <b>{{player.ladderName}}</b>.
            </span>
            <span *ngIf="player.levelId > 1 && player.isDoubles">
              You are in <b>{{player.levelName}}</b> on ladder <b>{{player.ladderName}}</b> on doubles team <b>{{player.doublesName}}</b>.
              (<a href="#" (click)="changeDoublesName($event)">change team name</a>)
            </span>
            <span>
              <i>This ladder will probably end {{ladderEndDate}}. (subject to change due to weather, holidays or other factors)</i>
            </span>
          </span>
          <br /><br />
          <!--
          <span *ngIf="REGISTRATION_OPEN">
            &nbsp;&nbsp;&nbsp;
            <a href="#" [routerLink]="['/nextladder']">Join Lubin's Next Ladder</a>
          </span>
          -->
          <span>
            Have a tennis question? Wondering about a rule? Ask the <a href="#" [routerLink]="['/ai/rules']">Lubin Ladder AI Bot</a>.
          </span>

        </td>
      </tr>
      <!-- 
      <tr>
        <td>This ladder will probably end {{ladderEndDate}}. (subject to change due to weather, holidays or other factors)</td>
      </tr>
      -->
    </table>
    <!-- -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= -->
    <div *ngIf="!player.paid && player.ladderId && player.levelId > 1 && player.ladderType != 'Tiebreak'">
      <hr />
      Please pay now - $35. (if you have already paid, we may still be processing payments)
      <br />
      Credit Card: <a target="_top" href="https://buy.stripe.com/dR6dSEfhr5PZfMQeUV">Stripe Payments</a>
      <br />
      Paypal: <a href="https://www.paypal.com/paypalme/bocatennisladder/35" target="_top">elubin&#64;elubin.com</a>
      <br />
      Venmo: &#64;elubincom (4-digits 9787)
      <br />
      Zelle: 561-213-7852
      <hr />
    </div>
    <!-- -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= -->

    <div *ngIf="!ladderEnded">
      <br />


      <button class="btn btn-primary" *ngIf="isTiebreakTourney" [routerLink]="['/record-tiebreak']">Record Match</button>
      <button class="btn btn-primary" *ngIf="!isTiebreakTourney" [routerLink]="['/record']">Record Match</button>

      <br /><br />
      <div *ngIf="scores.scores.length == 0">No matches recorded yet.</div>
      <table *ngIf="scores.scores.length > 0" class="table table-bordered">
        <thead>
          <tr>
            <th>Round</th>
            <th>Opponent</th>
            <th>Score</th>
            <th class="hide-small">Points</th>
            <th class="hide-small">Date</th>
            <th width="1%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of scores.scores">
            <td>
              {{s.round}}
            </td>
            <td><a [routerLink]="['/player',s.opponentId]">{{s.opponentFullName}}</a></td>

            <td *ngIf="isTiebreakTourney" [ngClass]="{'win':s.points==10, 'loss':s.points<10}">{{s.score}}</td>
            <td *ngIf="!isTiebreakTourney" [ngClass]="getCssClass(s)">{{s.score}}</td>

            <td class="hide-small">{{s.points}}</td>
            <td class="hide-small">{{s.getDate()}}</td>
            <td width="1%">
              <span *ngIf="s.recordedBy === player.id && s.isLessThanWeekOld()" style="cursor: pointer;"
                (click)="delete($event,s.matchId, s.opponentFullName)">
                <fa-icon [icon]="faTrash"></fa-icon>
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot class="hide-small">
          <tr>
            <td colspan="3" align="right">TOTAL</td>
            <td>{{scores.totalPoints}}</td>
            <td></td>
            <td width="1%"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <ng-container *ngIf="debug">
    <hr />
    {{player|json}}
    <hr />
    {{scores|json}}
  </ng-container>
</div>

<div *ngIf="!busy && ladderEnded">
  <img [routerLink]="['/profile']" [src]="avatar || '/assets/avatar.png'" height="70" width="70"
  style="border-radius: 50%; border: 3px solid black;" />
  <br /><br />
  <p>Hi <b>{{player.getFullName()}}</b>.</p>
  <p>
    <b>Ladder {{player.ladderName}} ended.</b>
  </p>
  <p>
    <span *ngIf="REGISTRATION_OPEN"><a href="#" [routerLink]="['/nextladder']">
      Join Lubin's Next Ladder</a>
    </span>
  </p>
  <span style="color: white;">{{player.ladderId}} - {{player.levelId}}</span>
  <div *ngIf="player.ladderId == '2024-7'">
  <h2>See the tournament <a href="#" [routerLink]="['/tournament', player.ladderId]">here</a>.</h2>
  </div>

  </div>

<div *ngIf="!busy && isStalker && !ladderEnded && !isWaitingRoom">
  <p>Hi <b>{{player.getFullName()}}</b>.</p>
  <p><b>You are only a viewer on ladder {{player.ladderName}}.</b></p>
  <p>
    <span style="margin-left: 15px;" *ngIf="REGISTRATION_OPEN"><a href="#" [routerLink]="['/nextladder']">Join
        Lubin's Next Ladder</a>
    </span>
  </p>
  <br />
  <allscores></allscores>
</div>

<div *ngIf="!busy && isWaitingRoom">
  <h3>Waiting Room</h3>
  <p>Hi <b>{{player.getFullName()}}</b>.</p>
  <p>You are currently hanging out in the waiting room looking for a match. These are all the players at all levels. You will be paired up at the correct level.
    As soon as we have 9 or more, at your level, we will start another ladder.</p>
  <p>Currently warming up on the courts...</p>
  <players [waitingRoom]="true"></players>
  <p *ngIf="!avatar">While you are waiting, please <a href="#" [routerLink]="['/profile']">upload your Avatar</a>.</p>
</div>
